<div class="page-layout">
  <app-sidebar></app-sidebar>

  <main class="main-content">
    <!-- Breadcrumb -->
    <nav class="breadcrumb">
      <a href="#" class="breadcrumb-item">
        <svg viewBox="0 0 24 24" class="breadcrumb-icon">
          <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      </a>
      <span class="breadcrumb-separator">›</span>
      <span class="breadcrumb-item active">Sessions</span>
    </nav>

    <!-- Page Header -->
    <header class="page-header">
      <h1 class="page-title">Sessions</h1>
    </header>

    <!-- Messages -->
    <div *ngIf="successMessage" class="alert alert-success">{{ successMessage }}</div>
    <div *ngIf="errorMessage && !showPlanModal && !showPaymentModal && !showAttendanceModal && !showCreatePurchaseModal" class="alert alert-error">{{ errorMessage }}</div>

    <!-- Tabs -->
    <mat-tab-group (selectedIndexChange)="onTabChange($event)" animationDuration="200ms">

      <!-- ═══════ Plans Tab ═══════ -->
      <mat-tab label="Plans" *ngIf="canViewPlans">
        <div class="tab-body">
          <div class="content-card">
            <div class="filters-row">
              <select class="form-select" [(ngModel)]="selectedSportId" (ngModelChange)="loadPlans()">
                <option value="">All Sports</option>
                <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
              </select>
              <button class="btn btn-primary btn-sm" *ngIf="canEditPlans" (click)="openAddPlan()">+ Add Plan</button>
            </div>
          </div>

          <div class="content-card">
            <h2 class="card-title">Session Plans ({{ plans.length }})</h2>

            <!-- Desktop table -->
            <div class="table-container hide-mobile">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Sport</th>
                    <th>Plan Name</th>
                    <th>Sessions</th>
                    <th>Price (EGP)</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="isLoading">
                    <td colspan="6" style="text-align:center; padding:2rem">Loading plans...</td>
                  </tr>
                  <tr *ngIf="!isLoading && plans.length === 0">
                    <td colspan="6" style="text-align:center; padding:2rem">No session plans found</td>
                  </tr>
                  <tr *ngFor="let plan of plans" class="table-row">
                    <td>{{ plan.sportName }}</td>
                    <td>{{ plan.name }}</td>
                    <td>{{ plan.sessionCount }}</td>
                    <td>
                      {{ plan.price | number:'1.0-2' }}
                      <span *ngIf="plan.branchPrices && plan.branchPrices.length > 0" class="branch-prices-hint">
                        <span *ngFor="let bp of plan.branchPrices" class="branch-price-tag">{{ bp.branchName }}: {{ bp.price | number:'1.0-2' }}</span>
                      </span>
                    </td>
                    <td>
                      <span class="status-badge" [ngClass]="plan.isActive ? 'status-verified' : 'status-unverified'">
                        {{ plan.isActive ? 'Active' : 'Inactive' }}
                      </span>
                    </td>
                    <td *ngIf="canEditPlans">
                      <div class="action-buttons">
                        <button class="btn btn-secondary btn-sm" (click)="openEditPlan(plan)">Edit</button>
                        <button class="btn btn-danger btn-sm" *ngIf="plan.isActive" (click)="deletePlan(plan)">Deactivate</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mobile cards -->
            <div class="mobile-cards show-mobile">
              <div *ngIf="isLoading" style="text-align:center; padding:2rem">Loading plans...</div>
              <div *ngIf="!isLoading && plans.length === 0" style="text-align:center; padding:2rem">No session plans found</div>
              <div class="mobile-card" *ngFor="let plan of plans">
                <div class="mobile-card-header">
                  <div>
                    <span class="mobile-card-title">{{ plan.name }}</span>
                    <span class="mobile-card-subtitle">{{ plan.sportName }}</span>
                  </div>
                  <span class="status-badge" [ngClass]="plan.isActive ? 'status-verified' : 'status-unverified'">
                    {{ plan.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </div>
                <div class="mobile-card-body">
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Sessions</span>
                    <span>{{ plan.sessionCount }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Price</span>
                    <span>{{ plan.price | number:'1.0-2' }} EGP</span>
                  </div>
                  <div *ngIf="plan.branchPrices && plan.branchPrices.length > 0" class="mobile-card-row">
                    <span class="mobile-card-label">Branches</span>
                    <span>
                      <span *ngFor="let bp of plan.branchPrices" class="branch-price-tag">{{ bp.branchName }}: {{ bp.price | number:'1.0-2' }}</span>
                    </span>
                  </div>
                </div>
                <div class="mobile-card-actions" *ngIf="canEditPlans">
                  <button class="btn btn-secondary btn-sm" (click)="openEditPlan(plan)">Edit</button>
                  <button class="btn btn-danger btn-sm" *ngIf="plan.isActive" (click)="deletePlan(plan)">Deactivate</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ═══════ Purchases Tab ═══════ -->
      <mat-tab label="Subscriptions" *ngIf="canViewSubscriptions">
        <div class="tab-body">
          <div class="content-card">
            <div class="filters-row">
              <select class="form-select" [(ngModel)]="selectedSportId">
                <option value="">All Sports</option>
                <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
              </select>
              <select class="form-select" [(ngModel)]="selectedBranchId">
                <option value="">All Branches</option>
                <option *ngFor="let branch of branches" [value]="branch.id">{{ branch.name }}</option>
              </select>
              <select class="form-select" [(ngModel)]="selectedMonth">
                <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">{{ getMonthName(m) }}</option>
              </select>
              <input type="number" class="form-input filter-year-input" [(ngModel)]="selectedYear" min="2024" max="2100"/>
              <select class="form-select" [(ngModel)]="selectedStatus">
                <option value="">All Statuses</option>
                <option value="PendingPayment">Pending Payment</option>
                <option value="Active">Active</option>
                <option value="Expired">Expired</option>
                <option value="Cancelled">Cancelled</option>
              </select>
              <button class="btn btn-primary btn-sm" (click)="loadPurchases()">Apply</button>
              <button class="btn btn-secondary btn-sm" *ngIf="canConfirmPayment" (click)="openCreatePurchaseModal()">+ Create Subscription</button>
            </div>
          </div>

          <div class="content-card">
            <h2 class="card-title">Subscriptions ({{ purchases.length }})</h2>

            <!-- Desktop table -->
            <div class="table-container hide-mobile">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Phone</th>
                    <th>Sport</th>
                    <th>Branch</th>
                    <th>Plan</th>
                    <th>Period</th>
                    <th>Sessions</th>
                    <th>Price</th>
                    <th>Pay Method</th>
                    <th>Payment</th>
                    <th>Paid On</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="isLoading">
                    <td colspan="13" style="text-align:center; padding:2rem">Loading subscriptions...</td>
                  </tr>
                  <tr *ngIf="!isLoading && purchases.length === 0">
                    <td colspan="13" style="text-align:center; padding:2rem">No subscriptions found</td>
                  </tr>
                  <tr *ngFor="let p of purchases" class="table-row">
                    <td>
                      {{ p.userName }}
                      <span *ngIf="p.subUserName" class="sub-user-tag">{{ p.subUserName }}</span>
                    </td>
                    <td>{{ p.userPhone }}</td>
                    <td>{{ p.sportName }}</td>
                    <td>{{ p.branchName }}</td>
                    <td>{{ p.planName }}</td>
                    <td>
                      <span *ngIf="p.selectedDate">{{ p.selectedDate | date:'mediumDate' }}</span>
                      <span *ngIf="!p.selectedDate">{{ getMonthName(p.month) }} {{ p.year }}</span>
                    </td>
                    <td>{{ p.sessionsUsed }}/{{ p.totalSessions }}</td>
                    <td>{{ p.appliedPrice | number:'1.0-2' }} EGP</td>
                    <td>
                      <span *ngIf="p.paymentMethod" class="status-badge" [ngClass]="p.paymentMethod === 'Cash' ? 'status-cash' : 'status-instapay'">
                        {{ p.paymentMethod }}
                      </span>
                      <button *ngIf="p.paymentProofUrl" class="proof-link" title="View payment proof" (click)="openProofModal(p.paymentProofUrl)">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg>
                      </button>
                      <span *ngIf="!p.paymentMethod">—</span>
                    </td>
                    <td>
                      <span class="status-badge" [ngClass]="getPaymentStatusClass(p.paymentStatus)">{{ p.paymentStatus }}</span>
                      <span class="payment-detail" *ngIf="p.remainingBalance > 0">({{ p.remainingBalance | number:'1.0-2' }} remaining)</span>
                    </td>
                    <td>
                      <span *ngIf="p.lastPaymentDate">{{ p.lastPaymentDate | date:'mediumDate' }}</span>
                      <span *ngIf="!p.lastPaymentDate">—</span>
                    </td>
                    <td>
                      <span class="status-badge" [ngClass]="getStatusClass(p.status)">{{ p.status }}</span>
                    </td>
                    <td>
                      <button class="btn btn-primary btn-sm" *ngIf="canConfirmPayment && p.paymentStatus !== 'FullyPaid'" (click)="openPaymentModal(p)">Record Payment</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mobile cards -->
            <div class="mobile-cards show-mobile">
              <div *ngIf="isLoading" style="text-align:center; padding:2rem">Loading subscriptions...</div>
              <div *ngIf="!isLoading && purchases.length === 0" style="text-align:center; padding:2rem">No subscriptions found</div>
              <div class="mobile-card" *ngFor="let p of purchases">
                <div class="mobile-card-header">
                  <div>
                    <span class="mobile-card-title">{{ p.userName }}<span *ngIf="p.subUserName" class="sub-user-tag">{{ p.subUserName }}</span></span>
                    <span class="mobile-card-subtitle">{{ p.userPhone }}</span>
                  </div>
                  <span class="status-badge" [ngClass]="getStatusClass(p.status)">{{ p.status }}</span>
                </div>
                <div class="mobile-card-body">
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Sport / Branch</span>
                    <span>{{ p.sportName }} — {{ p.branchName }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Plan</span>
                    <span>{{ p.planName }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Period</span>
                    <span *ngIf="p.selectedDate">{{ p.selectedDate | date:'mediumDate' }}</span>
                    <span *ngIf="!p.selectedDate">{{ getMonthName(p.month) }} {{ p.year }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Sessions</span>
                    <span>{{ p.sessionsUsed }}/{{ p.totalSessions }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Price</span>
                    <span>{{ p.appliedPrice | number:'1.0-2' }} EGP</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Payment</span>
                    <span>
                      <span class="status-badge" [ngClass]="getPaymentStatusClass(p.paymentStatus)">{{ p.paymentStatus }}</span>
                      <span *ngIf="p.paymentMethod" class="status-badge" style="margin-left:4px" [ngClass]="p.paymentMethod === 'Cash' ? 'status-cash' : 'status-instapay'">{{ p.paymentMethod }}</span>
                      <span class="payment-detail" *ngIf="p.remainingBalance > 0">({{ p.remainingBalance | number:'1.0-2' }} left)</span>
                    </span>
                  </div>
                  <div class="mobile-card-row" *ngIf="p.lastPaymentDate">
                    <span class="mobile-card-label">Paid On</span>
                    <span>{{ p.lastPaymentDate | date:'mediumDate' }}</span>
                  </div>
                </div>
                <div class="mobile-card-actions" *ngIf="canConfirmPayment && p.paymentStatus !== 'FullyPaid'">
                  <button class="btn btn-primary btn-sm" (click)="openPaymentModal(p)">Record Payment</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ═══════ Attendance Tab ═══════ -->
      <mat-tab label="Attendance" *ngIf="canAddAttendance">
        <div class="tab-body">
          <div class="content-card">
            <div class="filters-row">
              <select class="form-select" [(ngModel)]="selectedSportId">
                <option value="">All Sports</option>
                <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
              </select>
              <select class="form-select" [(ngModel)]="selectedMonth">
                <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">{{ getMonthName(m) }}</option>
              </select>
              <input type="number" class="form-input filter-year-input" [(ngModel)]="selectedYear" min="2024" max="2100"/>
              <button class="btn btn-primary btn-sm" (click)="loadAttendanceHistory()">Apply</button>
              <button class="btn btn-secondary btn-sm" (click)="openScanner()">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M9.5 6.5v3h-3v-3h3M11 5H5v6h6V5zm-1.5 9.5v3h-3v-3h3M11 13H5v6h6v-6zm6.5-6.5v3h-3v-3h3M19 5h-6v6h6V5zm-6 8h1.5v1.5H13V13zm1.5 1.5H16V16h-1.5v-1.5zM16 13h1.5v1.5H16V13zm-3 3h1.5v1.5H13V16zm1.5 1.5H16V19h-1.5v-1.5zM16 16h1.5v1.5H16V16zm1.5-1.5H19V16h-1.5v-1.5zm0 3H19V19h-1.5v-1.5zM3 3v2H1V1h4v2H3zm18-2v4h-2V3h-2V1h4zM3 19H1v4h4v-2H3v-2zm18 2h-2v2h4v-4h-2v2z"/></svg>
                Scan QR
              </button>
              <button class="btn btn-secondary btn-sm" (click)="openAttendanceModal()">+ Record Attendance</button>
            </div>
          </div>

          <div class="content-card">
            <h2 class="card-title">Attendance Records ({{ attendanceRecords.length }})</h2>

            <!-- Desktop table -->
            <div class="table-container hide-mobile">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Phone</th>
                    <th>Sport</th>
                    <th>Branch</th>
                    <th>Date</th>
                    <th>Recorded By</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="isLoading">
                    <td colspan="7" style="text-align:center; padding:2rem">Loading attendance...</td>
                  </tr>
                  <tr *ngIf="!isLoading && attendanceRecords.length === 0">
                    <td colspan="7" style="text-align:center; padding:2rem">No attendance records found</td>
                  </tr>
                  <tr *ngFor="let a of attendanceRecords" class="table-row">
                    <td>
                      {{ a.userName }}
                      <span *ngIf="a.subUserName" class="sub-user-tag">{{ a.subUserName }}</span>
                    </td>
                    <td>{{ a.userPhone }}</td>
                    <td>{{ a.sportName }}</td>
                    <td>{{ a.branchName }}</td>
                    <td>{{ formatDate(a.attendanceDate) }}</td>
                    <td>{{ a.recordedByName }}</td>
                    <td>
                      <button class="btn btn-danger btn-sm" (click)="undoAttendance(a)">Undo</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mobile cards -->
            <div class="mobile-cards show-mobile">
              <div *ngIf="isLoading" style="text-align:center; padding:2rem">Loading attendance...</div>
              <div *ngIf="!isLoading && attendanceRecords.length === 0" style="text-align:center; padding:2rem">No attendance records found</div>
              <div class="mobile-card" *ngFor="let a of attendanceRecords">
                <div class="mobile-card-header">
                  <div>
                    <span class="mobile-card-title">{{ a.userName }}<span *ngIf="a.subUserName" class="sub-user-tag">{{ a.subUserName }}</span></span>
                    <span class="mobile-card-subtitle">{{ a.userPhone }}</span>
                  </div>
                  <span class="mobile-card-subtitle">{{ formatDate(a.attendanceDate) }}</span>
                </div>
                <div class="mobile-card-body">
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Sport</span>
                    <span>{{ a.sportName }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Branch</span>
                    <span>{{ a.branchName }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Recorded By</span>
                    <span>{{ a.recordedByName }}</span>
                  </div>
                </div>
                <div class="mobile-card-actions">
                  <button class="btn btn-danger btn-sm" (click)="undoAttendance(a)">Undo</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <!-- ═══════ Reports Tab ═══════ -->
      <mat-tab label="Reports" *ngIf="canViewSubscriptions">
        <div class="tab-body">
          <div class="content-card">
            <div class="filters-row">
              <select class="form-select" [(ngModel)]="selectedSportId">
                <option value="">All Sports</option>
                <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
              </select>
              <select class="form-select" [(ngModel)]="selectedMonth">
                <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">{{ getMonthName(m) }}</option>
              </select>
              <input type="number" class="form-input filter-year-input" [(ngModel)]="selectedYear" min="2024" max="2100"/>
              <button class="btn btn-primary btn-sm" (click)="loadReport()">Generate Report</button>
              <button class="btn btn-secondary btn-sm" (click)="exportReportCsv()" *ngIf="report && report.rows.length > 0">Export CSV</button>
            </div>
          </div>

          <div class="content-card" *ngIf="report">
            <div class="report-summary">
              <div class="summary-item">
                <span class="summary-label">Period</span>
                <span class="summary-value">{{ getMonthName(report.month) }} {{ report.year }}</span>
              </div>
              <div class="summary-item" *ngIf="report.sportFilter">
                <span class="summary-label">Sport</span>
                <span class="summary-value">{{ report.sportFilter }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Total Attendances</span>
                <span class="summary-value">{{ report.totalAttendances }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Active Subscriptions</span>
                <span class="summary-value">{{ report.totalActiveSubscriptions }}</span>
              </div>
            </div>
          </div>

          <div class="content-card" *ngIf="report">
            <h2 class="card-title">Attendance Report ({{ report.rows.length }})</h2>

            <!-- Desktop table -->
            <div class="table-container hide-mobile">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Phone</th>
                    <th>Sport</th>
                    <th>Plan</th>
                    <th>Total Sessions</th>
                    <th>Attended</th>
                    <th>Remaining</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngIf="isLoading">
                    <td colspan="8" style="text-align:center; padding:2rem">Loading report...</td>
                  </tr>
                  <tr *ngIf="!isLoading && report.rows.length === 0">
                    <td colspan="8" style="text-align:center; padding:2rem">No data found for this period</td>
                  </tr>
                  <tr *ngFor="let row of report.rows" class="table-row">
                    <td>
                      {{ row.userName }}
                      <span *ngIf="row.subUserName" class="sub-user-tag">{{ row.subUserName }}</span>
                    </td>
                    <td>{{ row.userPhone }}</td>
                    <td>{{ row.sportName }}</td>
                    <td>{{ row.planName }}</td>
                    <td>{{ row.totalSessions }}</td>
                    <td>{{ row.attendanceCount }}</td>
                    <td>{{ row.remainingSessions }}</td>
                    <td>
                      <span class="status-badge" [ngClass]="getStatusClass(row.status)">{{ row.status }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Mobile cards -->
            <div class="mobile-cards show-mobile">
              <div *ngIf="isLoading" style="text-align:center; padding:2rem">Loading report...</div>
              <div class="mobile-card" *ngFor="let row of report.rows">
                <div class="mobile-card-header">
                  <div>
                    <span class="mobile-card-title">{{ row.userName }}<span *ngIf="row.subUserName" class="sub-user-tag">{{ row.subUserName }}</span></span>
                    <span class="mobile-card-subtitle">{{ row.userPhone }}</span>
                  </div>
                  <span class="status-badge" [ngClass]="getStatusClass(row.status)">{{ row.status }}</span>
                </div>
                <div class="mobile-card-body">
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Sport / Plan</span>
                    <span>{{ row.sportName }} — {{ row.planName }}</span>
                  </div>
                  <div class="mobile-card-row">
                    <span class="mobile-card-label">Sessions</span>
                    <span>{{ row.attendanceCount }}/{{ row.totalSessions }} ({{ row.remainingSessions }} left)</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

    </mat-tab-group>
  </main>
</div>

<!-- ═══════ Plan Modal ═══════ -->
<div class="modal-overlay" *ngIf="showPlanModal" (click)="closePlanModal()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ isEditingPlan ? 'Edit' : 'Add' }} Session Plan</h2>
      <button class="modal-close" (click)="closePlanModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

      <div class="form-group">
        <label class="form-label">Sport</label>
        <select class="form-input" [(ngModel)]="planForm.sportId" [disabled]="isEditingPlan || isSavingPlan">
          <option value="">Select Sport</option>
          <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">Plan Name</label>
        <input type="text" class="form-input" [(ngModel)]="planForm.name" placeholder="e.g. Monthly, Half-Month, Per Session" [disabled]="isSavingPlan"/>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label class="form-label">Session Count</label>
          <input type="number" class="form-input" [(ngModel)]="planForm.sessionCount" min="1" [disabled]="isSavingPlan"/>
        </div>
        <div class="form-group">
          <label class="form-label">Default Price (EGP)</label>
          <input type="number" class="form-input" [(ngModel)]="planForm.price" min="0.01" step="0.01" [disabled]="isSavingPlan"/>
        </div>
      </div>

      <div class="branch-pricing-section" *ngIf="branchPriceInputs.length > 0">
        <label class="section-label">Branch Pricing</label>
        <p class="section-hint">Set a price per branch. Leave empty if the plan is not available at that branch.</p>
        <div class="branch-price-row" *ngFor="let bp of branchPriceInputs">
          <span class="branch-name">{{ bp.branchName }}</span>
          <input type="number" class="form-input branch-price-input" [(ngModel)]="bp.price" min="0.01" step="0.01" placeholder="Price (EGP)" [disabled]="isSavingPlan"/>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closePlanModal()" [disabled]="isSavingPlan">Cancel</button>
      <button class="btn btn-primary" (click)="savePlan()" [disabled]="isSavingPlan">
        {{ isSavingPlan ? 'Saving...' : (isEditingPlan ? 'Update' : 'Create') }}
      </button>
    </div>
  </div>
</div>

<!-- ═══════ Payment Modal ═══════ -->
<div class="modal-overlay" *ngIf="showPaymentModal" (click)="closePaymentModal()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Record Payment</h2>
      <button class="modal-close" (click)="closePaymentModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

      <div class="purchase-summary" *ngIf="selectedPurchase">
        <p><strong>{{ selectedPurchase.userName }}</strong><span *ngIf="selectedPurchase.subUserName"> → {{ selectedPurchase.subUserName }}</span> - {{ selectedPurchase.planName }} ({{ selectedPurchase.sportName }})</p>
        <p>
          <span *ngIf="selectedPurchase.selectedDate">{{ selectedPurchase.selectedDate | date:'mediumDate' }}</span>
          <span *ngIf="!selectedPurchase.selectedDate">{{ getMonthName(selectedPurchase.month) }} {{ selectedPurchase.year }}</span>
          | Price: {{ selectedPurchase.appliedPrice | number:'1.0-2' }} EGP
          | Paid: {{ selectedPurchase.totalPaid | number:'1.0-2' }} EGP
          | Remaining: {{ selectedPurchase.remainingBalance | number:'1.0-2' }} EGP
        </p>
      </div>

      <div class="form-group">
        <label class="form-label">Amount (EGP)</label>
        <input type="number" class="form-input" [(ngModel)]="paymentForm.amount" min="0.01" step="0.01" [disabled]="isSavingPayment"/>
      </div>

      <div class="form-group">
        <label class="form-label">Payment Method</label>
        <select class="form-input" [(ngModel)]="paymentForm.paymentMethod" [disabled]="isSavingPayment">
          <option *ngFor="let method of paymentMethods" [value]="method">{{ method }}</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">Payment Date</label>
        <input type="date" class="form-input" [(ngModel)]="paymentForm.paymentDate" [disabled]="isSavingPayment"/>
      </div>

      <div class="form-group">
        <label class="form-label">Transaction Reference</label>
        <input type="text" class="form-input" [(ngModel)]="paymentForm.transactionReference" placeholder="Optional" [disabled]="isSavingPayment"/>
      </div>

      <div class="form-group">
        <label class="form-label">Notes</label>
        <textarea class="form-input" rows="2" [(ngModel)]="paymentForm.notes" placeholder="Optional" [disabled]="isSavingPayment"></textarea>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closePaymentModal()" [disabled]="isSavingPayment">Cancel</button>
      <button class="btn btn-primary" (click)="savePayment()" [disabled]="isSavingPayment">
        {{ isSavingPayment ? 'Saving...' : 'Record Payment' }}
      </button>
    </div>
  </div>
</div>

<!-- ═══════ QR Scanner Modal ═══════ -->
<div class="modal-overlay" *ngIf="showScannerModal" (click)="closeScanner()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Scan Subscription QR Code</h2>
      <button class="modal-close" (click)="closeScanner()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="scannerError" class="alert alert-error">{{ scannerError }}</div>
      <div *ngIf="scannerSuccess" class="alert alert-success">{{ scannerSuccess }}</div>
      <div id="qr-reader" class="qr-reader-container"></div>
      <p class="scanner-hint">Point your camera at the subscriber's QR code</p>
    </div>
  </div>
</div>

<!-- ═══════ Attendance Modal ═══════ -->
<div class="modal-overlay" *ngIf="showAttendanceModal" (click)="closeAttendanceModal()">
  <div class="modal-panel" (click)="$event.stopPropagation(); closeAutocompletePanel()">
    <div class="modal-header">
      <h2 class="modal-title">Record Attendance</h2>
      <button class="modal-close" (click)="closeAttendanceModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

      <div class="form-group">
        <label class="form-label">Sport</label>
        <select class="form-input" [(ngModel)]="selectedSportIdForAttendance" [disabled]="isSavingAttendance" (ngModelChange)="loadFilteredPurchases()">
          <option value="">Select Sport</option>
          <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
        </select>
      </div>

      <div class="form-group">
        <label class="form-label">Attendance Date</label>
        <input type="date" class="form-input" [(ngModel)]="attendanceDateForFilter" [disabled]="isSavingAttendance" (ngModelChange)="loadFilteredPurchases()"/>
      </div>

      <div class="form-group" (click)="$event.stopPropagation()">
        <label class="form-label">Select Subscriber</label>
        <input class="form-input"
               [(ngModel)]="subscriberSearch"
               [matAutocomplete]="subscriberAuto"
               [disabled]="isSavingAttendance"
               placeholder="Search by name or phone..."/>
        <mat-autocomplete #subscriberAuto="matAutocomplete"
          [displayWith]="displayPurchaseName"
          (optionSelected)="onPurchaseSelect($event)">
          <mat-option *ngFor="let p of filteredPurchases"
                      [value]="p"
                      [disabled]="p.sessionsUsed >= p.totalSessions">
            <div class="subscriber-option">
              <span class="subscriber-name">{{ p.subUserName ? p.userName + ' → ' + p.subUserName : p.userName }}</span>
              <span class="subscriber-details">
                <span class="subscriber-phone">{{ p.userPhone }}</span>
                <span class="subscriber-sessions" [class.exhausted]="p.sessionsUsed >= p.totalSessions">
                  {{ p.sessionsUsed }}/{{ p.totalSessions }}
                </span>
              </span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="form-group">
        <label class="form-label">Branch</label>
        <select class="form-input" [(ngModel)]="attendanceForm.branchId" [disabled]="isSavingAttendance">
          <option value="">Select Branch</option>
          <option *ngFor="let branch of branches" [value]="branch.id">{{ branch.name }}</option>
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeAttendanceModal()" [disabled]="isSavingAttendance">Cancel</button>
      <button class="btn btn-primary" (click)="saveAttendance()" [disabled]="isSavingAttendance">
        {{ isSavingAttendance ? 'Saving...' : 'Record Attendance' }}
      </button>
    </div>
  </div>
</div>

<!-- ═══════ Create Purchase Modal ═══════ -->
<div class="modal-overlay" *ngIf="showCreatePurchaseModal" (click)="closeCreatePurchaseModal()">
  <div class="modal-panel" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Create Subscription</h2>
      <button class="modal-close" (click)="closeCreatePurchaseModal()">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path fill="currentColor" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="errorMessage" class="alert alert-error">{{ errorMessage }}</div>

      <!-- User search -->
      <div class="form-group user-search-group">
        <label class="form-label">User</label>
        <input type="text" class="form-input"
          [(ngModel)]="purchaseUserSearch"
          (input)="searchPurchaseUsers()"
          [disabled]="isSavingPurchase"
          autocomplete="off"
          placeholder="Search by name or phone..."/>
        <div class="user-search-results" *ngIf="purchaseUsers.length > 0">
          <div class="user-search-item" *ngFor="let u of purchaseUsers" (click)="selectPurchaseUser(u)">
            <span class="user-search-name">{{ u.name }}</span>
            <span class="user-search-phone">{{ u.phoneNumber }}</span>
          </div>
        </div>
      </div>

      <!-- Subscribing for -->
      <div class="form-group" *ngIf="purchaseSelectedUser">
        <label class="form-label">Subscribing for</label>
        <select class="form-input" [(ngModel)]="purchaseForm.subUserId" [disabled]="isSavingPurchase">
          <option [ngValue]="undefined">{{ purchaseSelectedUser.name }} (Themselves)</option>
          <option *ngFor="let sub of purchaseSubUsers" [value]="sub.id">{{ sub.name }} ({{ sub.relationship }})</option>
        </select>
      </div>

      <!-- Sport -->
      <div class="form-group">
        <label class="form-label">Sport</label>
        <select class="form-input" [(ngModel)]="purchaseSportId" (ngModelChange)="onPurchaseSportChange($event)" [disabled]="isSavingPurchase">
          <option value="">Select Sport</option>
          <option *ngFor="let sport of sports" [value]="sport.id">{{ sport.name }}</option>
        </select>
      </div>

      <!-- Branch -->
      <div class="form-group">
        <label class="form-label">Branch</label>
        <select class="form-input" [(ngModel)]="purchaseForm.branchId" [disabled]="isSavingPurchase">
          <option value="">Select Branch</option>
          <option *ngFor="let branch of branches" [value]="branch.id">{{ branch.name }}</option>
        </select>
      </div>

      <!-- Plan -->
      <div class="form-group">
        <label class="form-label">{{ purchasePlans.length === 0 ? 'Select a sport first' : 'Plan' }}</label>
        <select class="form-input" [(ngModel)]="purchaseForm.sessionPlanId" [disabled]="isSavingPurchase || purchasePlans.length === 0">
          <option value="">Select Plan</option>
          <option *ngFor="let plan of purchasePlans" [value]="plan.id">{{ getPlanDisplayPrice(plan) }}</option>
        </select>
      </div>

      <!-- Single session date -->
      <div class="form-group" *ngIf="isSelectedPlanSingleSession()">
        <label class="form-label">Session Date</label>
        <input type="date" class="form-input" [(ngModel)]="purchaseForm.selectedDate" [disabled]="isSavingPurchase"/>
      </div>

      <!-- Month & Year -->
      <div class="form-row" *ngIf="!isSelectedPlanSingleSession()">
        <div class="form-group">
          <label class="form-label">Month</label>
          <select class="form-input" [(ngModel)]="purchaseForm.month" [disabled]="isSavingPurchase">
            <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">{{ getMonthName(m) }}</option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-label">Year</label>
          <input type="number" class="form-input" [(ngModel)]="purchaseForm.year" min="2024" max="2100" [disabled]="isSavingPurchase"/>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeCreatePurchaseModal()" [disabled]="isSavingPurchase">Cancel</button>
      <button class="btn btn-primary" (click)="savePurchase()" [disabled]="isSavingPurchase">
        {{ isSavingPurchase ? 'Creating...' : 'Create Subscription' }}
      </button>
    </div>
  </div>
</div>
